import React from "react";
import PropTypes from "prop-types";
import PlayerLinkFormatter from "./PlayerLinkFormatter";

const PreferredNameFormatter = ({ value, row, profileType, displayStyle, className }) => {
  // Determine the name to display
  const displayName = row.rosterFirstName || row.firstName;

  // Use PlayerLinkFormatter to wrap the displayName
  return (
    <PlayerLinkFormatter
      value={displayName}
      row={row}
      profileType={profileType}
      displayStyle={displayStyle}
      className={className}
    />
  );
};

PreferredNameFormatter.propTypes = {
  value: PropTypes.string,
  row: PropTypes.object,
  profileType: PropTypes.string,
  displayStyle: PropTypes.string,
  className: PropTypes.string
};

export default PreferredNameFormatter;
